import React, { useRef, useEffect, useState } from "react";
import { theme } from "../utils/theme";
import { Flex, Box, Image } from "rebass";
import PropTypes from "prop-types";
import { getLocalizedString } from "../utils";

const ModalLayout = ({ show, onClose, children, width }) => {
  // The gray background
  const backdropStyle = {
    position: "fixed",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: "rgba(0,0,0,0.6)",
    padding: 50,
    overflow: "auto",
    zIndex: 1200,
  };

  // TODO: Fix the height of the window so it scrolls when the viewport is too short (useWindowSize hook)
  // The modal "window"
  const modalStyle = {
    backgroundColor: theme.background,
    margin: "0 auto",
    position: "absolute",
    maxWidth: 1200,
    minWidth: width ? width : 600,
    top: 50,
    right: 0,
    left: 0,
    borderRadius: 5,
    marginBottom: 30,
    paddingBottom: 0,
    paddingTop: 25,
    minHeight: null,
  };

  const closeStyle = {
    position: "absolute",
    top: -30,
    right: -13,
    marginTop: 0,
    marginRight: 5,
    borderRadius: "3px",
    color: theme.white,
    paddingBottom: "4px",
    fontSize: 21,
    fontWeight: "700",
    cursor: "pointer",
  };

  if (show) {
    return (
      <Flex w={1} className="backdrop" style={backdropStyle}>
        <Flex
          flexDirection="column"
          width={1}
          className="modal"
          style={modalStyle}
        >
          <div style={closeStyle} onClick={onClose}>
            x
          </div>
          {
            //<i style={closeStyle} className="ne ne-cross" onClick={onClose}></i>
          }

          <Flex width={1} flexGrow={1} p={3}>
            {children}
          </Flex>
        </Flex>
      </Flex>
    );
  }
};

ModalLayout.propTypes = {
  onClose: PropTypes.func.isRequired,
  show: PropTypes.bool,
  children: PropTypes.node,
};
export { ModalLayout };
